<template>
    <slot :hasHeaders="BstkCSVImportData.addNewRecords" :toggle="toggleCreateMissing">
        <label v-bind="labelAttributes">
            <input
                type="checkbox"
                v-bind="checkboxAttributes"
                :checked="BstkCSVImportData.addNewRecords"
                @change="toggleCreateMissing"
            >
            {{ labels.toggleMissing }}
        </label>
    </slot>
</template>

<script>
    import {inject} from 'vue';

    /* eslint-disable */
    export default {
        name: "ToggleCreateMissing",
        props: {
            labelAttributes: {},
            checkboxAttributes: {},
        },
        setup() {
            const BstkCSVImportData = inject('BstkCSVImportData');
            const labels = BstkCSVImportData.language;

            const toggleCreateMissing = function () {
                BstkCSVImportData.addNewRecords = !BstkCSVImportData.addNewRecords;
            }

            return {
                BstkCSVImportData,
                toggleCreateMissing,
                labels
            }
        },
    };
</script>